/**
 * SimpleBar.js - v5.1.0
 * Scrollbars, simpler.
 * https://grsmto.github.io/simplebar/
 *
 * Made by Adrien Denat from a fork by Jonathan Nicol
 * Under MIT License
 */

!function (t, e) {
	if ("object" == typeof exports && "undefined" != typeof module) {
		module.exports = e();
	} else if ("function" == typeof define && define.amd) {
		define(e);
	} else {
		(t = t || self).SimpleBar = e();
	}
}(this, (function () {
	"use strict";
	var t = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};
	function e(t, e) {
		return t(e = {exports: {}}, e.exports), e.exports
	}
	var r, n, i, o = "object", s = function (t) {
		return t && t.Math == Math && t
	}, a = s(typeof globalThis == o && globalThis) || s(typeof window == o && window) || s(typeof self == o && self) || s(typeof t == o && t) || Function("return this")(), c = function (t) {
		try {
			return!!t()
		} catch (t) {
			return!0
		}
	}, l = !c((function () {
		return 7 != Object.defineProperty({}, "a", {get: function () {
				return 7
			}}).a
	})), u = {}.propertyIsEnumerable, f = Object.getOwnPropertyDescriptor, h = {f: f && !u.call({1: 2}, 1) ? function (t) {
			var e = f(this, t);
			return!!e && e.enumerable
		} : u}, d = function (t, e) {
		return{enumerable: !(1 & t), configurable: !(2 & t), writable: !(4 & t), value: e}
	}, p = {}.toString, v = function (t) {
		return p.call(t).slice(8, -1)
	}, g = "".split, y = c((function () {
		return!Object("z").propertyIsEnumerable(0)
	})) ? function (t) {
		return"String" == v(t) ? g.call(t, "") : Object(t)
	} : Object, b = function (t) {
		if (null == t)
			throw TypeError("Can't call method on " + t);
		return t
	}, m = function (t) {
		return y(b(t))
	}, x = function (t) {
		return"object" == typeof t ? null !== t : "function" == typeof t
	}, E = function (t, e) {
		if (!x(t))
			return t;
		var r, n;
		if (e && "function" == typeof (r = t.toString) && !x(n = r.call(t)))
			return n;
		if ("function" == typeof (r = t.valueOf) && !x(n = r.call(t)))
			return n;
		if (!e && "function" == typeof (r = t.toString) && !x(n = r.call(t)))
			return n;
		throw TypeError("Can't convert object to primitive value")
	}, w = {}.hasOwnProperty, O = function (t, e) {
		return w.call(t, e)
	}, _ = a.document, S = x(_) && x(_.createElement), A = function (t) {
		return S ? _.createElement(t) : {}
	}, k = !l && !c((function () {
		return 7 != Object.defineProperty(A("div"), "a", {get: function () {
				return 7
			}}).a
	})), L = Object.getOwnPropertyDescriptor, M = {f: l ? L : function (t, e) {
			if (t = m(t), e = E(e, !0), k)
				try {
					return L(t, e)
				} catch (t) {
				}
			if (O(t, e))
				return d(!h.f.call(t, e), t[e])
		}}, T = function (t) {
		if (!x(t))
			throw TypeError(String(t) + " is not an object");
		return t
	}, j = Object.defineProperty, R = {f: l ? j : function (t, e, r) {
			if (T(t), e = E(e, !0), T(r), k)
				try {
					return j(t, e, r)
				} catch (t) {
				}
			if ("get"in r || "set"in r)
				throw TypeError("Accessors not supported");
			return"value"in r && (t[e] = r.value), t
		}}, W = l ? function (t, e, r) {
		return R.f(t, e, d(1, r))
	} : function (t, e, r) {
		return t[e] = r, t
	}, z = function (t, e) {
		try {
			W(a, t, e)
		} catch (r) {
			a[t] = e
		}
		return e
	}, C = e((function (t) {
		var e = a["__core-js_shared__"] || z("__core-js_shared__", {});
		(t.exports = function (t, r) {
			return e[t] || (e[t] = void 0 !== r ? r : {})
		})("versions", []).push({version: "3.2.1", mode: "global", copyright: "© 2019 Denis Pushkarev (zloirock.ru)"})
	})), N = C("native-function-to-string", Function.toString), I = a.WeakMap, D = "function" == typeof I && /native code/.test(N.call(I)), P = 0, V = Math.random(), F = function (t) {
		return"Symbol(" + String(void 0 === t ? "" : t) + ")_" + (++P + V).toString(36)
	}, B = C("keys"), H = function (t) {
		return B[t] || (B[t] = F(t))
	}, q = {}, $ = a.WeakMap;
	if (D) {
		var X = new $, Y = X.get, G = X.has, U = X.set;
		r = function (t, e) {
			return U.call(X, t, e), e
		}, n = function (t) {
			return Y.call(X, t) || {}
		}, i = function (t) {
			return G.call(X, t)
		}
	} else {
		var Q = H("state");
		q[Q] = !0, r = function (t, e) {
			return W(t, Q, e), e
		}, n = function (t) {
			return O(t, Q) ? t[Q] : {}
		}, i = function (t) {
			return O(t, Q)
		}
	}
	var K = {set: r, get: n, has: i, enforce: function (t) {
			return i(t) ? n(t) : r(t, {})
		}, getterFor: function (t) {
			return function (e) {
				var r;
				if (!x(e) || (r = n(e)).type !== t)
					throw TypeError("Incompatible receiver, " + t + " required");
				return r
			}
		}}, J = e((function (t) {
		var e = K.get, r = K.enforce, n = String(N).split("toString");
		C("inspectSource", (function (t) {
			return N.call(t)
		})), (t.exports = function (t, e, i, o) {
			var s = !!o && !!o.unsafe, c = !!o && !!o.enumerable, l = !!o && !!o.noTargetGet;
			"function" == typeof i && ("string" != typeof e || O(i, "name") || W(i, "name", e), r(i).source = n.join("string" == typeof e ? e : "")), t !== a ? (s ? !l && t[e] && (c = !0) : delete t[e], c ? t[e] = i : W(t, e, i)) : c ? t[e] = i : z(e, i)
		})(Function.prototype, "toString", (function () {
			return"function" == typeof this && e(this).source || N.call(this)
		}))
	})), Z = a, tt = function (t) {
		return"function" == typeof t ? t : void 0
	}, et = function (t, e) {
		return arguments.length < 2 ? tt(Z[t]) || tt(a[t]) : Z[t] && Z[t][e] || a[t] && a[t][e]
	}, rt = Math.ceil, nt = Math.floor, it = function (t) {
		return isNaN(t = +t) ? 0 : (t > 0 ? nt : rt)(t)
	}, ot = Math.min, st = function (t) {
		return t > 0 ? ot(it(t), 9007199254740991) : 0
	}, at = Math.max, ct = Math.min, lt = function (t) {
		return function (e, r, n) {
			var i, o = m(e), s = st(o.length), a = function (t, e) {
				var r = it(t);
				return r < 0 ? at(r + e, 0) : ct(r, e)
			}(n, s);
			if (t && r != r) {
				for (; s > a; )
					if ((i = o[a++]) != i)
						return!0
			} else
				for (; s > a; a++)
					if ((t || a in o) && o[a] === r)
						return t || a || 0;
			return!t && -1
		}
	}, ut = {includes: lt(!0), indexOf: lt(!1)}.indexOf, ft = function (t, e) {
		var r, n = m(t), i = 0, o = [];
		for (r in n)
			!O(q, r) && O(n, r) && o.push(r);
		for (; e.length > i; )
			O(n, r = e[i++]) && (~ut(o, r) || o.push(r));
		return o
	}, ht = ["constructor", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "toLocaleString", "toString", "valueOf"], dt = ht.concat("length", "prototype"), pt = {f: Object.getOwnPropertyNames || function (t) {
			return ft(t, dt)
		}}, vt = {f: Object.getOwnPropertySymbols}, gt = et("Reflect", "ownKeys") || function (t) {
		var e = pt.f(T(t)), r = vt.f;
		return r ? e.concat(r(t)) : e
	}, yt = function (t, e) {
		for (var r = gt(e), n = R.f, i = M.f, o = 0; o < r.length; o++) {
			var s = r[o];
			O(t, s) || n(t, s, i(e, s))
		}
	}, bt = /#|\.prototype\./, mt = function (t, e) {
		var r = Et[xt(t)];
		return r == Ot || r != wt && ("function" == typeof e ? c(e) : !!e)
	}, xt = mt.normalize = function (t) {
		return String(t).replace(bt, ".").toLowerCase()
	}, Et = mt.data = {}, wt = mt.NATIVE = "N", Ot = mt.POLYFILL = "P", _t = mt, St = M.f, At = function (t, e) {
		var r, n, i, o, s, c = t.target, l = t.global, u = t.stat;
		if (r = l ? a : u ? a[c] || z(c, {}) : (a[c] || {}).prototype)
			for (n in e) {
				if (o = e[n], i = t.noTargetGet ? (s = St(r, n)) && s.value : r[n], !_t(l ? n : c + (u ? "." : "#") + n, t.forced) && void 0 !== i) {
					if (typeof o == typeof i)
						continue;
					yt(o, i)
				}
				(t.sham || i && i.sham) && W(o, "sham", !0), J(r, n, o, t)
			}
	}, kt = function (t) {
		if ("function" != typeof t)
			throw TypeError(String(t) + " is not a function");
		return t
	}, Lt = function (t, e, r) {
		if (kt(t), void 0 === e)
			return t;
		switch (r) {
			case 0:
				return function () {
					return t.call(e)
				};
			case 1:
				return function (r) {
					return t.call(e, r)
				};
			case 2:
				return function (r, n) {
					return t.call(e, r, n)
				};
			case 3:
				return function (r, n, i) {
					return t.call(e, r, n, i)
				}
		}
		return function () {
			return t.apply(e, arguments)
		}
	}, Mt = function (t) {
		return Object(b(t))
	}, Tt = Array.isArray || function (t) {
		return"Array" == v(t)
	}, jt = !!Object.getOwnPropertySymbols && !c((function () {
		return!String(Symbol())
	})), Rt = a.Symbol, Wt = C("wks"), zt = function (t) {
		return Wt[t] || (Wt[t] = jt && Rt[t] || (jt ? Rt : F)("Symbol." + t))
	}, Ct = zt("species"), Nt = function (t, e) {
		var r;
		return Tt(t) && ("function" != typeof (r = t.constructor) || r !== Array && !Tt(r.prototype) ? x(r) && null === (r = r[Ct]) && (r = void 0) : r = void 0), new (void 0 === r ? Array : r)(0 === e ? 0 : e)
	}, It = [].push, Dt = function (t) {
		var e = 1 == t, r = 2 == t, n = 3 == t, i = 4 == t, o = 6 == t, s = 5 == t || o;
		return function (a, c, l, u) {
			for (var f, h, d = Mt(a), p = y(d), v = Lt(c, l, 3), g = st(p.length), b = 0, m = u || Nt, x = e ? m(a, g) : r ? m(a, 0) : void 0; g > b; b++)
				if ((s || b in p) && (h = v(f = p[b], b, d), t))
					if (e)
						x[b] = h;
					else if (h)
						switch (t) {
							case 3:
								return!0;
							case 5:
								return f;
							case 6:
								return b;
							case 2:
								It.call(x, f)
						}
					else if (i)
						return!1;
			return o ? -1 : n || i ? i : x
		}
	}, Pt = {forEach: Dt(0), map: Dt(1), filter: Dt(2), some: Dt(3), every: Dt(4), find: Dt(5), findIndex: Dt(6)}, Vt = function (t, e) {
		var r = [][t];
		return!r || !c((function () {
			r.call(null, e || function () {
				throw 1
			}, 1)
		}))
	}, Ft = Pt.forEach, Bt = Vt("forEach") ? function (t) {
		return Ft(this, t, arguments.length > 1 ? arguments[1] : void 0)
	} : [].forEach;
	At({target: "Array", proto: !0, forced: [].forEach != Bt}, {forEach: Bt});
	var Ht = {CSSRuleList: 0, CSSStyleDeclaration: 0, CSSValueList: 0, ClientRectList: 0, DOMRectList: 0, DOMStringList: 0, DOMTokenList: 1, DataTransferItemList: 0, FileList: 0, HTMLAllCollection: 0, HTMLCollection: 0, HTMLFormElement: 0, HTMLSelectElement: 0, MediaList: 0, MimeTypeArray: 0, NamedNodeMap: 0, NodeList: 1, PaintRequestList: 0, Plugin: 0, PluginArray: 0, SVGLengthList: 0, SVGNumberList: 0, SVGPathSegList: 0, SVGPointList: 0, SVGStringList: 0, SVGTransformList: 0, SourceBufferList: 0, StyleSheetList: 0, TextTrackCueList: 0, TextTrackList: 0, TouchList: 0};
	for (var qt in Ht) {
		var $t = a[qt], Xt = $t && $t.prototype;
		if (Xt && Xt.forEach !== Bt)
			try {
				W(Xt, "forEach", Bt)
			} catch (t) {
				Xt.forEach = Bt
			}
	}
	var Yt = !("undefined" == typeof window || !window.document || !window.document.createElement), Gt = zt("species"), Ut = Pt.filter;
	At({target: "Array", proto: !0, forced: !function (t) {
			return!c((function () {
				var e = [];
				return(e.constructor = {})[Gt] = function () {
					return{foo: 1}
				}, 1 !== e[t](Boolean).foo
			}))
		}("filter")}, {filter: function (t) {
			return Ut(this, t, arguments.length > 1 ? arguments[1] : void 0)
		}});
	var Qt = Object.keys || function (t) {
		return ft(t, ht)
	}, Kt = l ? Object.defineProperties : function (t, e) {
		T(t);
		for (var r, n = Qt(e), i = n.length, o = 0; i > o; )
			R.f(t, r = n[o++], e[r]);
		return t
	}, Jt = et("document", "documentElement"), Zt = H("IE_PROTO"), te = function () {}, ee = function () {
		var t, e = A("iframe"), r = ht.length;
		for (e.style.display = "none", Jt.appendChild(e), e.src = String("javascript:"), (t = e.contentWindow.document).open(), t.write("<script>document.F=Object<\/script>"), t.close(), ee = t.F; r--; )
			delete ee.prototype[ht[r]];
		return ee()
	}, re = Object.create || function (t, e) {
		var r;
		return null !== t ? (te.prototype = T(t), r = new te, te.prototype = null, r[Zt] = t) : r = ee(), void 0 === e ? r : Kt(r, e)
	};
	q[Zt] = !0;
	var ne = zt("unscopables"), ie = Array.prototype;
	null == ie[ne] && W(ie, ne, re(null));
	var oe, se, ae, ce = function (t) {
		ie[ne][t] = !0
	}, le = {}, ue = !c((function () {
		function t() {}
		return t.prototype.constructor = null, Object.getPrototypeOf(new t) !== t.prototype
	})), fe = H("IE_PROTO"), he = Object.prototype, de = ue ? Object.getPrototypeOf : function (t) {
		return t = Mt(t), O(t, fe) ? t[fe] : "function" == typeof t.constructor && t instanceof t.constructor ? t.constructor.prototype : t instanceof Object ? he : null
	}, pe = zt("iterator"), ve = !1;
	[].keys && ("next"in(ae = [].keys()) ? (se = de(de(ae))) !== Object.prototype && (oe = se) : ve = !0), null == oe && (oe = {}), O(oe, pe) || W(oe, pe, (function () {
		return this
	}));
	var ge = {IteratorPrototype: oe, BUGGY_SAFARI_ITERATORS: ve}, ye = R.f, be = zt("toStringTag"), me = function (t, e, r) {
		t && !O(t = r ? t : t.prototype, be) && ye(t, be, {configurable: !0, value: e})
	}, xe = ge.IteratorPrototype, Ee = function () {
		return this
	}, we = Object.setPrototypeOf || ("__proto__"in{} ? function () {
		var t, e = !1, r = {};
		try {
			(t = Object.getOwnPropertyDescriptor(Object.prototype, "__proto__").set).call(r, []), e = r instanceof Array
		} catch (t) {
		}
		return function (r, n) {
			return T(r), function (t) {
				if (!x(t) && null !== t)
					throw TypeError("Can't set " + String(t) + " as a prototype")
			}(n), e ? t.call(r, n) : r.__proto__ = n, r
		}
	}() : void 0), Oe = ge.IteratorPrototype, _e = ge.BUGGY_SAFARI_ITERATORS, Se = zt("iterator"), Ae = function () {
		return this
	}, ke = function (t, e, r, n, i, o, s) {
		!function (t, e, r) {
			var n = e + " Iterator";
			t.prototype = re(xe, {next: d(1, r)}), me(t, n, !1), le[n] = Ee
		}(r, e, n);
		var a, c, l, u = function (t) {
			if (t === i && g)
				return g;
			if (!_e && t in p)
				return p[t];
			switch (t) {
				case"keys":
				case"values":
				case"entries":
					return function () {
						return new r(this, t)
					}
			}
			return function () {
				return new r(this)
			}
		}, f = e + " Iterator", h = !1, p = t.prototype, v = p[Se] || p["@@iterator"] || i && p[i], g = !_e && v || u(i), y = "Array" == e && p.entries || v;
		if (y && (a = de(y.call(new t)), Oe !== Object.prototype && a.next && (de(a) !== Oe && (we ? we(a, Oe) : "function" != typeof a[Se] && W(a, Se, Ae)), me(a, f, !0))), "values" == i && v && "values" !== v.name && (h = !0, g = function () {
			return v.call(this)
		}), p[Se] !== g && W(p, Se, g), le[e] = g, i)
			if (c = {values: u("values"), keys: o ? g : u("keys"), entries: u("entries")}, s)
				for (l in c)
					!_e && !h && l in p || J(p, l, c[l]);
			else
				At({target: e, proto: !0, forced: _e || h}, c);
		return c
	}, Le = K.set, Me = K.getterFor("Array Iterator"), Te = ke(Array, "Array", (function (t, e) {
		Le(this, {type: "Array Iterator", target: m(t), index: 0, kind: e})
	}), (function () {
		var t = Me(this), e = t.target, r = t.kind, n = t.index++;
		return!e || n >= e.length ? (t.target = void 0, {value: void 0, done: !0}) : "keys" == r ? {value: n, done: !1} : "values" == r ? {value: e[n], done: !1} : {value: [n, e[n]], done: !1}
	}), "values");
	le.Arguments = le.Array, ce("keys"), ce("values"), ce("entries");
	var je = Object.assign, Re = !je || c((function () {
		var t = {}, e = {}, r = Symbol();
		return t[r] = 7, "abcdefghijklmnopqrst".split("").forEach((function (t) {
			e[t] = t
		})), 7 != je({}, t)[r] || "abcdefghijklmnopqrst" != Qt(je({}, e)).join("")
	})) ? function (t, e) {
		for (var r = Mt(t), n = arguments.length, i = 1, o = vt.f, s = h.f; n > i; )
			for (var a, c = y(arguments[i++]), u = o ? Qt(c).concat(o(c)) : Qt(c), f = u.length, d = 0; f > d; )
				a = u[d++], l && !s.call(c, a) || (r[a] = c[a]);
		return r
	} : je;
	At({target: "Object", stat: !0, forced: Object.assign !== Re}, {assign: Re});
	var We = zt("toStringTag"), ze = "Arguments" == v(function () {
		return arguments
	}()), Ce = function (t) {
		var e, r, n;
		return void 0 === t ? "Undefined" : null === t ? "Null" : "string" == typeof (r = function (t, e) {
			try {
				return t[e]
			} catch (t) {
			}
		}(e = Object(t), We)) ? r : ze ? v(e) : "Object" == (n = v(e)) && "function" == typeof e.callee ? "Arguments" : n
	}, Ne = {};
	Ne[zt("toStringTag")] = "z";
	var Ie = "[object z]" !== String(Ne) ? function () {
		return"[object " + Ce(this) + "]"
	} : Ne.toString, De = Object.prototype;
	Ie !== De.toString && J(De, "toString", Ie, {unsafe: !0});
	var Pe = "\t\n\v\f\r                　\u2028\u2029\ufeff", Ve = "[" + Pe + "]", Fe = RegExp("^" + Ve + Ve + "*"), Be = RegExp(Ve + Ve + "*$"), He = function (t) {
		return function (e) {
			var r = String(b(e));
			return 1 & t && (r = r.replace(Fe, "")), 2 & t && (r = r.replace(Be, "")), r
		}
	}, qe = {start: He(1), end: He(2), trim: He(3)}.trim, $e = a.parseInt, Xe = /^[+-]?0[Xx]/, Ye = 8 !== $e(Pe + "08") || 22 !== $e(Pe + "0x16") ? function (t, e) {
		var r = qe(String(t));
		return $e(r, e >>> 0 || (Xe.test(r) ? 16 : 10))
	} : $e;
	At({global: !0, forced: parseInt != Ye}, {parseInt: Ye});
	var Ge = function (t) {
		return function (e, r) {
			var n, i, o = String(b(e)), s = it(r), a = o.length;
			return s < 0 || s >= a ? t ? "" : void 0 : (n = o.charCodeAt(s)) < 55296 || n > 56319 || s + 1 === a || (i = o.charCodeAt(s + 1)) < 56320 || i > 57343 ? t ? o.charAt(s) : n : t ? o.slice(s, s + 2) : i - 56320 + (n - 55296 << 10) + 65536
		}
	}, Ue = {codeAt: Ge(!1), charAt: Ge(!0)}, Qe = Ue.charAt, Ke = K.set, Je = K.getterFor("String Iterator");
	ke(String, "String", (function (t) {
		Ke(this, {type: "String Iterator", string: String(t), index: 0})
	}), (function () {
		var t, e = Je(this), r = e.string, n = e.index;
		return n >= r.length ? {value: void 0, done: !0} : (t = Qe(r, n), e.index += t.length, {value: t, done: !1})
	}));
	var Ze = function (t, e, r) {
		for (var n in e)
			J(t, n, e[n], r);
		return t
	}, tr = !c((function () {
		return Object.isExtensible(Object.preventExtensions({}))
	})), er = e((function (t) {
		var e = R.f, r = F("meta"), n = 0, i = Object.isExtensible || function () {
			return!0
		}, o = function (t) {
			e(t, r, {value: {objectID: "O" + ++n, weakData: {}}})
		}, s = t.exports = {REQUIRED: !1, fastKey: function (t, e) {
				if (!x(t))
					return"symbol" == typeof t ? t : ("string" == typeof t ? "S" : "P") + t;
				if (!O(t, r)) {
					if (!i(t))
						return"F";
					if (!e)
						return"E";
					o(t)
				}
				return t[r].objectID
			}, getWeakData: function (t, e) {
				if (!O(t, r)) {
					if (!i(t))
						return!0;
					if (!e)
						return!1;
					o(t)
				}
				return t[r].weakData
			}, onFreeze: function (t) {
				return tr && s.REQUIRED && i(t) && !O(t, r) && o(t), t
			}};
		q[r] = !0
	})), rr = (er.REQUIRED, er.fastKey, er.getWeakData, er.onFreeze, zt("iterator")), nr = Array.prototype, ir = zt("iterator"), or = function (t, e, r, n) {
		try {
			return n ? e(T(r)[0], r[1]) : e(r)
		} catch (e) {
			var i = t.return;
			throw void 0 !== i && T(i.call(t)), e
		}
	}, sr = e((function (t) {
		var e = function (t, e) {
			this.stopped = t, this.result = e
		};
		(t.exports = function (t, r, n, i, o) {
			var s, a, c, l, u, f, h, d = Lt(r, n, i ? 2 : 1);
			if (o)
				s = t;
			else {
				if ("function" != typeof (a = function (t) {
					if (null != t)
						return t[ir] || t["@@iterator"] || le[Ce(t)]
				}(t)))
					throw TypeError("Target is not iterable");
				if (void 0 !== (h = a) && (le.Array === h || nr[rr] === h)) {
					for (c = 0, l = st(t.length); l > c; c++)
						if ((u = i ? d(T(f = t[c])[0], f[1]) : d(t[c])) && u instanceof e)
							return u;
					return new e(!1)
				}
				s = a.call(t)
			}
			for (; !(f = s.next()).done; )
				if ((u = or(s, d, f.value, i)) && u instanceof e)
					return u;
			return new e(!1)
		}).stop = function (t) {
			return new e(!0, t)
		}
	})), ar = function (t, e, r) {
		if (!(t instanceof e))
			throw TypeError("Incorrect " + (r ? r + " " : "") + "invocation");
		return t
	}, cr = zt("iterator"), lr = !1;
	try {
		var ur = 0, fr = {next: function () {
				return{done: !!ur++}
			}, return: function () {
				lr = !0
			}};
		fr[cr] = function () {
			return this
		}, Array.from(fr, (function () {
			throw 2
		}))
	} catch (t) {
	}
	var hr = function (t, e, r, n, i) {
		var o = a[t], s = o && o.prototype, l = o, u = n ? "set" : "add", f = {}, h = function (t) {
			var e = s[t];
			J(s, t, "add" == t ? function (t) {
				return e.call(this, 0 === t ? 0 : t), this
			} : "delete" == t ? function (t) {
				return!(i && !x(t)) && e.call(this, 0 === t ? 0 : t)
			} : "get" == t ? function (t) {
				return i && !x(t) ? void 0 : e.call(this, 0 === t ? 0 : t)
			} : "has" == t ? function (t) {
				return!(i && !x(t)) && e.call(this, 0 === t ? 0 : t)
			} : function (t, r) {
				return e.call(this, 0 === t ? 0 : t, r), this
			})
		};
		if (_t(t, "function" != typeof o || !(i || s.forEach && !c((function () {
			(new o).entries().next()
		})))))
			l = r.getConstructor(e, t, n, u), er.REQUIRED = !0;
		else if (_t(t, !0)) {
			var d = new l, p = d[u](i ? {} : -0, 1) != d, v = c((function () {
				d.has(1)
			})), g = function (t, e) {
				if (!e && !lr)
					return!1;
				var r = !1;
				try {
					var n = {};
					n[cr] = function () {
						return{next: function () {
								return{done: r = !0}
							}}
					}, t(n)
				} catch (t) {
				}
				return r
			}((function (t) {
				new o(t)
			})), y = !i && c((function () {
				for (var t = new o, e = 5; e--; )
					t[u](e, e);
				return!t.has(-0)
			}));
			g || ((l = e((function (e, r) {
				ar(e, l, t);
				var i = function (t, e, r) {
					var n, i;
					return we && "function" == typeof (n = e.constructor) && n !== r && x(i = n.prototype) && i !== r.prototype && we(t, i), t
				}(new o, e, l);
				return null != r && sr(r, i[u], i, n), i
			}))).prototype = s, s.constructor = l), (v || y) && (h("delete"), h("has"), n && h("get")), (y || p) && h(u), i && s.clear && delete s.clear
		}
		return f[t] = l, At({global: !0, forced: l != o}, f), me(l, t), i || r.setStrong(l, t, n), l
	}, dr = er.getWeakData, pr = K.set, vr = K.getterFor, gr = Pt.find, yr = Pt.findIndex, br = 0, mr = function (t) {
		return t.frozen || (t.frozen = new xr)
	}, xr = function () {
		this.entries = []
	}, Er = function (t, e) {
		return gr(t.entries, (function (t) {
			return t[0] === e
		}))
	};
	xr.prototype = {get: function (t) {
			var e = Er(this, t);
			if (e)
				return e[1]
		}, has: function (t) {
			return!!Er(this, t)
		}, set: function (t, e) {
			var r = Er(this, t);
			r ? r[1] = e : this.entries.push([t, e])
		}, delete: function (t) {
			var e = yr(this.entries, (function (e) {
				return e[0] === t
			}));
			return~e && this.entries.splice(e, 1), !!~e
		}};
	var wr = {getConstructor: function (t, e, r, n) {
			var i = t((function (t, o) {
				ar(t, i, e), pr(t, {type: e, id: br++, frozen: void 0}), null != o && sr(o, t[n], t, r)
			})), o = vr(e), s = function (t, e, r) {
				var n = o(t), i = dr(T(e), !0);
				return!0 === i ? mr(n).set(e, r) : i[n.id] = r, t
			};
			return Ze(i.prototype, {delete: function (t) {
					var e = o(this);
					if (!x(t))
						return!1;
					var r = dr(t);
					return!0 === r ? mr(e).delete(t) : r && O(r, e.id) && delete r[e.id]
				}, has: function (t) {
					var e = o(this);
					if (!x(t))
						return!1;
					var r = dr(t);
					return!0 === r ? mr(e).has(t) : r && O(r, e.id)
				}}), Ze(i.prototype, r ? {get: function (t) {
					var e = o(this);
					if (x(t)) {
						var r = dr(t);
						return!0 === r ? mr(e).get(t) : r ? r[e.id] : void 0
					}
				}, set: function (t, e) {
					return s(this, t, e)
				}} : {add: function (t) {
					return s(this, t, !0)
				}}), i
		}}, Or = (e((function (t) {
		var e, r = K.enforce, n = !a.ActiveXObject && "ActiveXObject"in a, i = Object.isExtensible, o = function (t) {
			return function () {
				return t(this, arguments.length ? arguments[0] : void 0)
			}
		}, s = t.exports = hr("WeakMap", o, wr, !0, !0);
		if (D && n) {
			e = wr.getConstructor(o, "WeakMap", !0), er.REQUIRED = !0;
			var c = s.prototype, l = c.delete, u = c.has, f = c.get, h = c.set;
			Ze(c, {delete: function (t) {
					if (x(t) && !i(t)) {
						var n = r(this);
						return n.frozen || (n.frozen = new e), l.call(this, t) || n.frozen.delete(t)
					}
					return l.call(this, t)
				}, has: function (t) {
					if (x(t) && !i(t)) {
						var n = r(this);
						return n.frozen || (n.frozen = new e), u.call(this, t) || n.frozen.has(t)
					}
					return u.call(this, t)
				}, get: function (t) {
					if (x(t) && !i(t)) {
						var n = r(this);
						return n.frozen || (n.frozen = new e), u.call(this, t) ? f.call(this, t) : n.frozen.get(t)
					}
					return f.call(this, t)
				}, set: function (t, n) {
					if (x(t) && !i(t)) {
						var o = r(this);
						o.frozen || (o.frozen = new e), u.call(this, t) ? h.call(this, t, n) : o.frozen.set(t, n)
					} else
						h.call(this, t, n);
					return this
				}})
		}
	})), zt("iterator")), _r = zt("toStringTag"), Sr = Te.values;
	for (var Ar in Ht) {
		var kr = a[Ar], Lr = kr && kr.prototype;
		if (Lr) {
			if (Lr[Or] !== Sr)
				try {
					W(Lr, Or, Sr)
				} catch (t) {
					Lr[Or] = Sr
				}
			if (Lr[_r] || W(Lr, _r, Ar), Ht[Ar])
				for (var Mr in Te)
					if (Lr[Mr] !== Te[Mr])
						try {
							W(Lr, Mr, Te[Mr])
						} catch (t) {
							Lr[Mr] = Te[Mr]
						}
		}
	}
	var Tr = "Expected a function", jr = NaN, Rr = "[object Symbol]", Wr = /^\s+|\s+$/g, zr = /^[-+]0x[0-9a-f]+$/i, Cr = /^0b[01]+$/i, Nr = /^0o[0-7]+$/i, Ir = parseInt, Dr = "object" == typeof t && t && t.Object === Object && t, Pr = "object" == typeof self && self && self.Object === Object && self, Vr = Dr || Pr || Function("return this")(), Fr = Object.prototype.toString, Br = Math.max, Hr = Math.min, qr = function () {
		return Vr.Date.now()
	};
	function $r(t, e, r) {
		var n, i, o, s, a, c, l = 0, u = !1, f = !1, h = !0;
		if ("function" != typeof t)
			throw new TypeError(Tr);
		function d(e) {
			var r = n, o = i;
			return n = i = void 0, l = e, s = t.apply(o, r)
		}
		function p(t) {
			var r = t - c;
			return void 0 === c || r >= e || r < 0 || f && t - l >= o
		}
		function v() {
			var t = qr();
			if (p(t))
				return g(t);
			a = setTimeout(v, function (t) {
				var r = e - (t - c);
				return f ? Hr(r, o - (t - l)) : r
			}(t))
		}
		function g(t) {
			return a = void 0, h && n ? d(t) : (n = i = void 0, s)
		}
		function y() {
			var t = qr(), r = p(t);
			if (n = arguments, i = this, c = t, r) {
				if (void 0 === a)
					return function (t) {
						return l = t, a = setTimeout(v, e), u ? d(t) : s
					}(c);
				if (f)
					return a = setTimeout(v, e), d(c)
			}
			return void 0 === a && (a = setTimeout(v, e)), s
		}
		return e = Yr(e) || 0, Xr(r) && (u = !!r.leading, o = (f = "maxWait"in r) ? Br(Yr(r.maxWait) || 0, e) : o, h = "trailing"in r ? !!r.trailing : h), y.cancel = function () {
			void 0 !== a && clearTimeout(a), l = 0, n = c = i = a = void 0
		}, y.flush = function () {
			return void 0 === a ? s : g(qr())
		}, y
	}
	function Xr(t) {
		var e = typeof t;
		return!!t && ("object" == e || "function" == e)
	}
	function Yr(t) {
		if ("number" == typeof t)
			return t;
		if (function (t) {
			return"symbol" == typeof t || function (t) {
				return!!t && "object" == typeof t
			}(t) && Fr.call(t) == Rr
		}(t))
			return jr;
		if (Xr(t)) {
			var e = "function" == typeof t.valueOf ? t.valueOf() : t;
			t = Xr(e) ? e + "" : e
		}
		if ("string" != typeof t)
			return 0 === t ? t : +t;
		t = t.replace(Wr, "");
		var r = Cr.test(t);
		return r || Nr.test(t) ? Ir(t.slice(2), r ? 2 : 8) : zr.test(t) ? jr : +t
	}
	var Gr = function (t, e, r) {
		var n = !0, i = !0;
		if ("function" != typeof t)
			throw new TypeError(Tr);
		return Xr(r) && (n = "leading"in r ? !!r.leading : n, i = "trailing"in r ? !!r.trailing : i), $r(t, e, {leading: n, maxWait: e, trailing: i})
	}, Ur = "Expected a function", Qr = NaN, Kr = "[object Symbol]", Jr = /^\s+|\s+$/g, Zr = /^[-+]0x[0-9a-f]+$/i, tn = /^0b[01]+$/i, en = /^0o[0-7]+$/i, rn = parseInt, nn = "object" == typeof t && t && t.Object === Object && t, on = "object" == typeof self && self && self.Object === Object && self, sn = nn || on || Function("return this")(), an = Object.prototype.toString, cn = Math.max, ln = Math.min, un = function () {
		return sn.Date.now()
	};
	function fn(t) {
		var e = typeof t;
		return!!t && ("object" == e || "function" == e)
	}
	function hn(t) {
		if ("number" == typeof t)
			return t;
		if (function (t) {
			return"symbol" == typeof t || function (t) {
				return!!t && "object" == typeof t
			}(t) && an.call(t) == Kr
		}(t))
			return Qr;
		if (fn(t)) {
			var e = "function" == typeof t.valueOf ? t.valueOf() : t;
			t = fn(e) ? e + "" : e
		}
		if ("string" != typeof t)
			return 0 === t ? t : +t;
		t = t.replace(Jr, "");
		var r = tn.test(t);
		return r || en.test(t) ? rn(t.slice(2), r ? 2 : 8) : Zr.test(t) ? Qr : +t
	}
	var dn = function (t, e, r) {
		var n, i, o, s, a, c, l = 0, u = !1, f = !1, h = !0;
		if ("function" != typeof t)
			throw new TypeError(Ur);
		function d(e) {
			var r = n, o = i;
			return n = i = void 0, l = e, s = t.apply(o, r)
		}
		function p(t) {
			var r = t - c;
			return void 0 === c || r >= e || r < 0 || f && t - l >= o
		}
		function v() {
			var t = un();
			if (p(t))
				return g(t);
			a = setTimeout(v, function (t) {
				var r = e - (t - c);
				return f ? ln(r, o - (t - l)) : r
			}(t))
		}
		function g(t) {
			return a = void 0, h && n ? d(t) : (n = i = void 0, s)
		}
		function y() {
			var t = un(), r = p(t);
			if (n = arguments, i = this, c = t, r) {
				if (void 0 === a)
					return function (t) {
						return l = t, a = setTimeout(v, e), u ? d(t) : s
					}(c);
				if (f)
					return a = setTimeout(v, e), d(c)
			}
			return void 0 === a && (a = setTimeout(v, e)), s
		}
		return e = hn(e) || 0, fn(r) && (u = !!r.leading, o = (f = "maxWait"in r) ? cn(hn(r.maxWait) || 0, e) : o, h = "trailing"in r ? !!r.trailing : h), y.cancel = function () {
			void 0 !== a && clearTimeout(a), l = 0, n = c = i = a = void 0
		}, y.flush = function () {
			return void 0 === a ? s : g(un())
		}, y
	}, pn = "Expected a function", vn = "__lodash_hash_undefined__", gn = "[object Function]", yn = "[object GeneratorFunction]", bn = /^\[object .+?Constructor\]$/, mn = "object" == typeof t && t && t.Object === Object && t, xn = "object" == typeof self && self && self.Object === Object && self, En = mn || xn || Function("return this")();
	var wn = Array.prototype, On = Function.prototype, _n = Object.prototype, Sn = En["__core-js_shared__"], An = function () {
		var t = /[^.]+$/.exec(Sn && Sn.keys && Sn.keys.IE_PROTO || "");
		return t ? "Symbol(src)_1." + t : ""
	}(), kn = On.toString, Ln = _n.hasOwnProperty, Mn = _n.toString, Tn = RegExp("^" + kn.call(Ln).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), jn = wn.splice, Rn = Vn(En, "Map"), Wn = Vn(Object, "create");
	function zn(t) {
		var e = -1, r = t ? t.length : 0;
		for (this.clear(); ++e < r; ) {
			var n = t[e];
			this.set(n[0], n[1])
		}
	}
	function Cn(t) {
		var e = -1, r = t ? t.length : 0;
		for (this.clear(); ++e < r; ) {
			var n = t[e];
			this.set(n[0], n[1])
		}
	}
	function Nn(t) {
		var e = -1, r = t ? t.length : 0;
		for (this.clear(); ++e < r; ) {
			var n = t[e];
			this.set(n[0], n[1])
		}
	}
	function In(t, e) {
		for (var r, n, i = t.length; i--; )
			if ((r = t[i][0]) === (n = e) || r != r && n != n)
				return i;
		return -1
	}
	function Dn(t) {
		return!(!Bn(t) || (e = t, An && An in e)) && (function (t) {
			var e = Bn(t) ? Mn.call(t) : "";
			return e == gn || e == yn
		}(t) || function (t) {
			var e = !1;
			if (null != t && "function" != typeof t.toString)
				try {
					e = !!(t + "")
				} catch (t) {
				}
			return e
		}(t) ? Tn : bn).test(function (t) {
			if (null != t) {
				try {
					return kn.call(t)
				} catch (t) {
				}
				try {
					return t + ""
				} catch (t) {
				}
			}
			return""
		}(t));
		var e
	}
	function Pn(t, e) {
		var r, n, i = t.__data__;
		return("string" == (n = typeof (r = e)) || "number" == n || "symbol" == n || "boolean" == n ? "__proto__" !== r : null === r) ? i["string" == typeof e ? "string" : "hash"] : i.map
	}
	function Vn(t, e) {
		var r = function (t, e) {
			return null == t ? void 0 : t[e]
		}(t, e);
		return Dn(r) ? r : void 0
	}
	function Fn(t, e) {
		if ("function" != typeof t || e && "function" != typeof e)
			throw new TypeError(pn);
		var r = function () {
			var n = arguments, i = e ? e.apply(this, n) : n[0], o = r.cache;
			if (o.has(i))
				return o.get(i);
			var s = t.apply(this, n);
			return r.cache = o.set(i, s), s
		};
		return r.cache = new (Fn.Cache || Nn), r
	}
	function Bn(t) {
		var e = typeof t;
		return!!t && ("object" == e || "function" == e)
	}
	zn.prototype.clear = function () {
		this.__data__ = Wn ? Wn(null) : {}
	}, zn.prototype.delete = function (t) {
		return this.has(t) && delete this.__data__[t]
	}, zn.prototype.get = function (t) {
		var e = this.__data__;
		if (Wn) {
			var r = e[t];
			return r === vn ? void 0 : r
		}
		return Ln.call(e, t) ? e[t] : void 0
	}, zn.prototype.has = function (t) {
		var e = this.__data__;
		return Wn ? void 0 !== e[t] : Ln.call(e, t)
	}, zn.prototype.set = function (t, e) {
		return this.__data__[t] = Wn && void 0 === e ? vn : e, this
	}, Cn.prototype.clear = function () {
		this.__data__ = []
	}, Cn.prototype.delete = function (t) {
		var e = this.__data__, r = In(e, t);
		return!(r < 0) && (r == e.length - 1 ? e.pop() : jn.call(e, r, 1), !0)
	}, Cn.prototype.get = function (t) {
		var e = this.__data__, r = In(e, t);
		return r < 0 ? void 0 : e[r][1]
	}, Cn.prototype.has = function (t) {
		return In(this.__data__, t) > -1
	}, Cn.prototype.set = function (t, e) {
		var r = this.__data__, n = In(r, t);
		return n < 0 ? r.push([t, e]) : r[n][1] = e, this
	}, Nn.prototype.clear = function () {
		this.__data__ = {hash: new zn, map: new (Rn || Cn), string: new zn}
	}, Nn.prototype.delete = function (t) {
		return Pn(this, t).delete(t)
	}, Nn.prototype.get = function (t) {
		return Pn(this, t).get(t)
	}, Nn.prototype.has = function (t) {
		return Pn(this, t).has(t)
	}, Nn.prototype.set = function (t, e) {
		return Pn(this, t).set(t, e), this
	}, Fn.Cache = Nn;
	var Hn = Fn, qn = function () {
		if ("undefined" != typeof Map)
			return Map;
		function t(t, e) {
			var r = -1;
			return t.some((function (t, n) {
				return t[0] === e && (r = n, !0)
			})), r
		}
		return function () {
			function e() {
				this.__entries__ = []
			}
			return Object.defineProperty(e.prototype, "size", {get: function () {
					return this.__entries__.length
				}, enumerable: !0, configurable: !0}), e.prototype.get = function (e) {
				var r = t(this.__entries__, e), n = this.__entries__[r];
				return n && n[1]
			}, e.prototype.set = function (e, r) {
				var n = t(this.__entries__, e);
				~n ? this.__entries__[n][1] = r : this.__entries__.push([e, r])
			}, e.prototype.delete = function (e) {
				var r = this.__entries__, n = t(r, e);
				~n && r.splice(n, 1)
			}, e.prototype.has = function (e) {
				return!!~t(this.__entries__, e)
			}, e.prototype.clear = function () {
				this.__entries__.splice(0)
			}, e.prototype.forEach = function (t, e) {
				void 0 === e && (e = null);
				for (var r = 0, n = this.__entries__; r < n.length; r++) {
					var i = n[r];
					t.call(e, i[1], i[0])
				}
			}, e
		}()
	}(), $n = "undefined" != typeof window && "undefined" != typeof document && window.document === document, Xn = "undefined" != typeof global && global.Math === Math ? global : "undefined" != typeof self && self.Math === Math ? self : "undefined" != typeof window && window.Math === Math ? window : Function("return this")(), Yn = "function" == typeof requestAnimationFrame ? requestAnimationFrame.bind(Xn) : function (t) {
		return setTimeout((function () {
			return t(Date.now())
		}), 1e3 / 60)
	}, Gn = 2;
	var Un = 20, Qn = ["top", "right", "bottom", "left", "width", "height", "size", "weight"], Kn = "undefined" != typeof MutationObserver, Jn = function () {
		function t() {
			this.connected_ = !1, this.mutationEventsAdded_ = !1, this.mutationsObserver_ = null, this.observers_ = [], this.onTransitionEnd_ = this.onTransitionEnd_.bind(this), this.refresh = function (t, e) {
				var r = !1, n = !1, i = 0;
				function o() {
					r && (r = !1, t()), n && a()
				}
				function s() {
					Yn(o)
				}
				function a() {
					var t = Date.now();
					if (r) {
						if (t - i < Gn)
							return;
						n = !0
					} else
						r = !0, n = !1, setTimeout(s, e);
					i = t
				}
				return a
			}(this.refresh.bind(this), Un)
		}
		return t.prototype.addObserver = function (t) {
			~this.observers_.indexOf(t) || this.observers_.push(t), this.connected_ || this.connect_()
		}, t.prototype.removeObserver = function (t) {
			var e = this.observers_, r = e.indexOf(t);
			~r && e.splice(r, 1), !e.length && this.connected_ && this.disconnect_()
		}, t.prototype.refresh = function () {
			this.updateObservers_() && this.refresh()
		}, t.prototype.updateObservers_ = function () {
			var t = this.observers_.filter((function (t) {
				return t.gatherActive(), t.hasActive()
			}));
			return t.forEach((function (t) {
				return t.broadcastActive()
			})), t.length > 0
		}, t.prototype.connect_ = function () {
			$n && !this.connected_ && (document.addEventListener("transitionend", this.onTransitionEnd_), window.addEventListener("resize", this.refresh), Kn ? (this.mutationsObserver_ = new MutationObserver(this.refresh), this.mutationsObserver_.observe(document, {attributes: !0, childList: !0, characterData: !0, subtree: !0})) : (document.addEventListener("DOMSubtreeModified", this.refresh), this.mutationEventsAdded_ = !0), this.connected_ = !0)
		}, t.prototype.disconnect_ = function () {
			$n && this.connected_ && (document.removeEventListener("transitionend", this.onTransitionEnd_), window.removeEventListener("resize", this.refresh), this.mutationsObserver_ && this.mutationsObserver_.disconnect(), this.mutationEventsAdded_ && document.removeEventListener("DOMSubtreeModified", this.refresh), this.mutationsObserver_ = null, this.mutationEventsAdded_ = !1, this.connected_ = !1)
		}, t.prototype.onTransitionEnd_ = function (t) {
			var e = t.propertyName, r = void 0 === e ? "" : e;
			Qn.some((function (t) {
				return!!~r.indexOf(t)
			})) && this.refresh()
		}, t.getInstance = function () {
			return this.instance_ || (this.instance_ = new t), this.instance_
		}, t.instance_ = null, t
	}(), Zn = function (t, e) {
		for (var r = 0, n = Object.keys(e); r < n.length; r++) {
			var i = n[r];
			Object.defineProperty(t, i, {value: e[i], enumerable: !1, writable: !1, configurable: !0})
		}
		return t
	}, ti = function (t) {
		return t && t.ownerDocument && t.ownerDocument.defaultView || Xn
	}, ei = ai(0, 0, 0, 0);
	function ri(t) {
		return parseFloat(t) || 0
	}
	function ni(t) {
		for (var e = [], r = 1; r < arguments.length; r++)
			e[r - 1] = arguments[r];
		return e.reduce((function (e, r) {
			return e + ri(t["border-" + r + "-width"])
		}), 0)
	}
	function ii(t) {
		var e = t.clientWidth, r = t.clientHeight;
		if (!e && !r)
			return ei;
		var n = ti(t).getComputedStyle(t), i = function (t) {
			for (var e = {}, r = 0, n = ["top", "right", "bottom", "left"]; r < n.length; r++) {
				var i = n[r], o = t["padding-" + i];
				e[i] = ri(o)
			}
			return e
		}(n), o = i.left + i.right, s = i.top + i.bottom, a = ri(n.width), c = ri(n.height);
		if ("border-box" === n.boxSizing && (Math.round(a + o) !== e && (a -= ni(n, "left", "right") + o), Math.round(c + s) !== r && (c -= ni(n, "top", "bottom") + s)), !function (t) {
			return t === ti(t).document.documentElement
		}(t)) {
			var l = Math.round(a + o) - e, u = Math.round(c + s) - r;
			1 !== Math.abs(l) && (a -= l), 1 !== Math.abs(u) && (c -= u)
		}
		return ai(i.left, i.top, a, c)
	}
	var oi = "undefined" != typeof SVGGraphicsElement ? function (t) {
		return t instanceof ti(t).SVGGraphicsElement
	} : function (t) {
		return t instanceof ti(t).SVGElement && "function" == typeof t.getBBox
	};
	function si(t) {
		return $n ? oi(t) ? function (t) {
			var e = t.getBBox();
			return ai(0, 0, e.width, e.height)
		}(t) : ii(t) : ei
	}
	function ai(t, e, r, n) {
		return{x: t, y: e, width: r, height: n}
	}
	var ci = function () {
		function t(t) {
			this.broadcastWidth = 0, this.broadcastHeight = 0, this.contentRect_ = ai(0, 0, 0, 0), this.target = t
		}
		return t.prototype.isActive = function () {
			var t = si(this.target);
			return this.contentRect_ = t, t.width !== this.broadcastWidth || t.height !== this.broadcastHeight
		}, t.prototype.broadcastRect = function () {
			var t = this.contentRect_;
			return this.broadcastWidth = t.width, this.broadcastHeight = t.height, t
		}, t
	}(), li = function (t, e) {
		var r, n, i, o, s, a, c, l = (n = (r = e).x, i = r.y, o = r.width, s = r.height, a = "undefined" != typeof DOMRectReadOnly ? DOMRectReadOnly : Object, c = Object.create(a.prototype), Zn(c, {x: n, y: i, width: o, height: s, top: i, right: n + o, bottom: s + i, left: n}), c);
		Zn(this, {target: t, contentRect: l})
	}, ui = function () {
		function t(t, e, r) {
			if (this.activeObservations_ = [], this.observations_ = new qn, "function" != typeof t)
				throw new TypeError("The callback provided as parameter 1 is not a function.");
			this.callback_ = t, this.controller_ = e, this.callbackCtx_ = r
		}
		return t.prototype.observe = function (t) {
			if (!arguments.length)
				throw new TypeError("1 argument required, but only 0 present.");
			if ("undefined" != typeof Element && Element instanceof Object) {
				if (!(t instanceof ti(t).Element))
					throw new TypeError('parameter 1 is not of type "Element".');
				var e = this.observations_;
				e.has(t) || (e.set(t, new ci(t)), this.controller_.addObserver(this), this.controller_.refresh())
			}
		}, t.prototype.unobserve = function (t) {
			if (!arguments.length)
				throw new TypeError("1 argument required, but only 0 present.");
			if ("undefined" != typeof Element && Element instanceof Object) {
				if (!(t instanceof ti(t).Element))
					throw new TypeError('parameter 1 is not of type "Element".');
				var e = this.observations_;
				e.has(t) && (e.delete(t), e.size || this.controller_.removeObserver(this))
			}
		}, t.prototype.disconnect = function () {
			this.clearActive(), this.observations_.clear(), this.controller_.removeObserver(this)
		}, t.prototype.gatherActive = function () {
			var t = this;
			this.clearActive(), this.observations_.forEach((function (e) {
				e.isActive() && t.activeObservations_.push(e)
			}))
		}, t.prototype.broadcastActive = function () {
			if (this.hasActive()) {
				var t = this.callbackCtx_, e = this.activeObservations_.map((function (t) {
					return new li(t.target, t.broadcastRect())
				}));
				this.callback_.call(t, e, t), this.clearActive()
			}
		}, t.prototype.clearActive = function () {
			this.activeObservations_.splice(0)
		}, t.prototype.hasActive = function () {
			return this.activeObservations_.length > 0
		}, t
	}(), fi = "undefined" != typeof WeakMap ? new WeakMap : new qn, hi = function t(e) {
		if (!(this instanceof t))
			throw new TypeError("Cannot call a class as a function.");
		if (!arguments.length)
			throw new TypeError("1 argument required, but only 0 present.");
		var r = Jn.getInstance(), n = new ui(e, r, this);
		fi.set(this, n)
	};
	["observe", "unobserve", "disconnect"].forEach((function (t) {
		hi.prototype[t] = function () {
			var e;
			return(e = fi.get(this))[t].apply(e, arguments)
		}
	}));
	var di = void 0 !== Xn.ResizeObserver ? Xn.ResizeObserver : hi, pi = null, vi = null;
	function gi() {
		if (null === pi) {
			if ("undefined" == typeof document)
				return pi = 0;
			var t = document.body, e = document.createElement("div");
			e.classList.add("simplebar-hide-scrollbar"), t.appendChild(e);
			var r = e.getBoundingClientRect().right;
			t.removeChild(e), pi = r
		}
		return pi
	}
	Yt && window.addEventListener("resize", (function () {
		vi !== window.devicePixelRatio && (vi = window.devicePixelRatio, pi = null)
	}));
	var yi = function (t) {
		return function (e, r, n, i) {
			kt(r);
			var o = Mt(e), s = y(o), a = st(o.length), c = t ? a - 1 : 0, l = t ? -1 : 1;
			if (n < 2)
				for (; ; ) {
					if (c in s) {
						i = s[c], c += l;
						break
					}
					if (c += l, t ? c < 0 : a <= c)
						throw TypeError("Reduce of empty array with no initial value")
				}
			for (; t?c >= 0:a > c; c += l)
				c in s && (i = r(i, s[c], c, o));
			return i
		}
	}, bi = {left: yi(!1), right: yi(!0)}.left;
	At({target: "Array", proto: !0, forced: Vt("reduce")}, {reduce: function (t) {
			return bi(this, t, arguments.length, arguments.length > 1 ? arguments[1] : void 0)
		}});
	var mi = R.f, xi = Function.prototype, Ei = xi.toString, wi = /^\s*function ([^ (]*)/;
	!l || "name"in xi || mi(xi, "name", {configurable: !0, get: function () {
			try {
				return Ei.call(this).match(wi)[1]
			} catch (t) {
				return""
			}
		}});
	var Oi, _i, Si = function () {
		var t = T(this), e = "";
		return t.global && (e += "g"), t.ignoreCase && (e += "i"), t.multiline && (e += "m"), t.dotAll && (e += "s"), t.unicode && (e += "u"), t.sticky && (e += "y"), e
	}, Ai = RegExp.prototype.exec, ki = String.prototype.replace, Li = Ai, Mi = (Oi = /a/, _i = /b*/g, Ai.call(Oi, "a"), Ai.call(_i, "a"), 0 !== Oi.lastIndex || 0 !== _i.lastIndex), Ti = void 0 !== /()??/.exec("")[1];
	(Mi || Ti) && (Li = function (t) {
		var e, r, n, i, o = this;
		return Ti && (r = new RegExp("^" + o.source + "$(?!\\s)", Si.call(o))), Mi && (e = o.lastIndex), n = Ai.call(o, t), Mi && n && (o.lastIndex = o.global ? n.index + n[0].length : e), Ti && n && n.length > 1 && ki.call(n[0], r, (function () {
			for (i = 1; i < arguments.length - 2; i++)
				void 0 === arguments[i] && (n[i] = void 0)
		})), n
	});
	var ji = Li;
	At({target: "RegExp", proto: !0, forced: /./.exec !== ji}, {exec: ji});
	var Ri = zt("species"), Wi = !c((function () {
		var t = /./;
		return t.exec = function () {
			var t = [];
			return t.groups = {a: "7"}, t
		}, "7" !== "".replace(t, "$<a>")
	})), zi = !c((function () {
		var t = /(?:)/, e = t.exec;
		t.exec = function () {
			return e.apply(this, arguments)
		};
		var r = "ab".split(t);
		return 2 !== r.length || "a" !== r[0] || "b" !== r[1]
	})), Ci = function (t, e, r, n) {
		var i = zt(t), o = !c((function () {
			var e = {};
			return e[i] = function () {
				return 7
			}, 7 != ""[t](e)
		})), s = o && !c((function () {
			var e = !1, r = /a/;
			return r.exec = function () {
				return e = !0, null
			}, "split" === t && (r.constructor = {}, r.constructor[Ri] = function () {
				return r
			}), r[i](""), !e
		}));
		if (!o || !s || "replace" === t && !Wi || "split" === t && !zi) {
			var a = /./[i], l = r(i, ""[t], (function (t, e, r, n, i) {
				return e.exec === ji ? o && !i ? {done: !0, value: a.call(e, r, n)} : {done: !0, value: t.call(r, e, n)} : {done: !1}
			})), u = l[0], f = l[1];
			J(String.prototype, t, u), J(RegExp.prototype, i, 2 == e ? function (t, e) {
				return f.call(t, this, e)
			} : function (t) {
				return f.call(t, this)
			}), n && W(RegExp.prototype[i], "sham", !0)
		}
	}, Ni = Ue.charAt, Ii = function (t, e, r) {
		return e + (r ? Ni(t, e).length : 1)
	}, Di = function (t, e) {
		var r = t.exec;
		if ("function" == typeof r) {
			var n = r.call(t, e);
			if ("object" != typeof n)
				throw TypeError("RegExp exec method returned something other than an Object or null");
			return n
		}
		if ("RegExp" !== v(t))
			throw TypeError("RegExp#exec called on incompatible receiver");
		return ji.call(t, e)
	};
	Ci("match", 1, (function (t, e, r) {
		return[function (e) {
				var r = b(this), n = null == e ? void 0 : e[t];
				return void 0 !== n ? n.call(e, r) : new RegExp(e)[t](String(r))
			}, function (t) {
				var n = r(e, t, this);
				if (n.done)
					return n.value;
				var i = T(t), o = String(this);
				if (!i.global)
					return Di(i, o);
				var s = i.unicode;
				i.lastIndex = 0;
				for (var a, c = [], l = 0; null !== (a = Di(i, o)); ) {
					var u = String(a[0]);
					c[l] = u, "" === u && (i.lastIndex = Ii(o, st(i.lastIndex), s)), l++
				}
				return 0 === l ? null : c
			}]
	}));
	var Pi = Math.max, Vi = Math.min, Fi = Math.floor, Bi = /\$([$&'`]|\d\d?|<[^>]*>)/g, Hi = /\$([$&'`]|\d\d?)/g;
	Ci("replace", 2, (function (t, e, r) {
		return[function (r, n) {
				var i = b(this), o = null == r ? void 0 : r[t];
				return void 0 !== o ? o.call(r, i, n) : e.call(String(i), r, n)
			}, function (t, i) {
				var o = r(e, t, this, i);
				if (o.done)
					return o.value;
				var s = T(t), a = String(this), c = "function" == typeof i;
				c || (i = String(i));
				var l = s.global;
				if (l) {
					var u = s.unicode;
					s.lastIndex = 0
				}
				for (var f = []; ; ) {
					var h = Di(s, a);
					if (null === h)
						break;
					if (f.push(h), !l)
						break;
					"" === String(h[0]) && (s.lastIndex = Ii(a, st(s.lastIndex), u))
				}
				for (var d, p = "", v = 0, g = 0; g < f.length; g++) {
					h = f[g];
					for (var y = String(h[0]), b = Pi(Vi(it(h.index), a.length), 0), m = [], x = 1; x < h.length; x++)
						m.push(void 0 === (d = h[x]) ? d : String(d));
					var E = h.groups;
					if (c) {
						var w = [y].concat(m, b, a);
						void 0 !== E && w.push(E);
						var O = String(i.apply(void 0, w))
					} else
						O = n(y, a, b, m, E, i);
					b >= v && (p += a.slice(v, b) + O, v = b + y.length)
				}
				return p + a.slice(v)
			}];
		function n(t, r, n, i, o, s) {
			var a = n + t.length, c = i.length, l = Hi;
			return void 0 !== o && (o = Mt(o), l = Bi), e.call(s, l, (function (e, s) {
				var l;
				switch (s.charAt(0)) {
					case"$":
						return"$";
					case"&":
						return t;
					case"`":
						return r.slice(0, n);
					case"'":
						return r.slice(a);
					case"<":
						l = o[s.slice(1, -1)];
						break;
					default:
						var u = +s;
						if (0 === u)
							return e;
						if (u > c) {
							var f = Fi(u / 10);
							return 0 === f ? e : f <= c ? void 0 === i[f - 1] ? s.charAt(1) : i[f - 1] + s.charAt(1) : e
						}
						l = i[u - 1]
				}
				return void 0 === l ? "" : l
			}))
		}
	}
	));
	var qi = function (t) {
		return Array.prototype.reduce.call(t, (function (t, e) {
			var r = e.name.match(/data-simplebar-(.+)/);
			if (r) {
				var n = r[1].replace(/\W+(.)/g, (function (t, e) {
					return e.toUpperCase()
				}));
				switch (e.value) {
					case"true":
						t[n] = !0;
						break;
					case"false":
						t[n] = !1;
						break;
					case void 0:
						t[n] = !0;
						break;
					default:
						t[n] = e.value
				}
			}
			return t
		}), {})
	};
	function $i(t) {
		return t && t.ownerDocument && t.ownerDocument.defaultView ? t.ownerDocument.defaultView : window
	}
	function Xi(t) {
		return t && t.ownerDocument ? t.ownerDocument : document
	}
	var Yi = function () {
		function t(e, r) {
			var n = this;
			this.onScroll = function () {
				var t = $i(n.el);
				n.scrollXTicking || (t.requestAnimationFrame(n.scrollX), n.scrollXTicking = !0), n.scrollYTicking || (t.requestAnimationFrame(n.scrollY), n.scrollYTicking = !0)
			}, this.scrollX = function () {
				n.axis.x.isOverflowing && (n.showScrollbar("x"), n.positionScrollbar("x")), n.scrollXTicking = !1
			}, this.scrollY = function () {
				n.axis.y.isOverflowing && (n.showScrollbar("y"), n.positionScrollbar("y")), n.scrollYTicking = !1
			}, this.onMouseEnter = function () {
				n.showScrollbar("x"), n.showScrollbar("y")
			}, this.onMouseMove = function (t) {
				n.mouseX = t.clientX, n.mouseY = t.clientY, (n.axis.x.isOverflowing || n.axis.x.forceVisible) && n.onMouseMoveForAxis("x"), (n.axis.y.isOverflowing || n.axis.y.forceVisible) && n.onMouseMoveForAxis("y")
			}, this.onMouseLeave = function () {
				n.onMouseMove.cancel(), (n.axis.x.isOverflowing || n.axis.x.forceVisible) && n.onMouseLeaveForAxis("x"), (n.axis.y.isOverflowing || n.axis.y.forceVisible) && n.onMouseLeaveForAxis("y"), n.mouseX = -1, n.mouseY = -1
			}, this.onWindowResize = function () {
				n.scrollbarWidth = n.getScrollbarWidth(), n.hideNativeScrollbar()
			}, this.hideScrollbars = function () {
				n.axis.x.track.rect = n.axis.x.track.el.getBoundingClientRect(), n.axis.y.track.rect = n.axis.y.track.el.getBoundingClientRect(), n.isWithinBounds(n.axis.y.track.rect) || (n.axis.y.scrollbar.el.classList.remove(n.classNames.visible), n.axis.y.isVisible = !1), n.isWithinBounds(n.axis.x.track.rect) || (n.axis.x.scrollbar.el.classList.remove(n.classNames.visible), n.axis.x.isVisible = !1)
			}, this.onPointerEvent = function (t) {
				var e, r;
				n.axis.x.track.rect = n.axis.x.track.el.getBoundingClientRect(), n.axis.y.track.rect = n.axis.y.track.el.getBoundingClientRect(), (n.axis.x.isOverflowing || n.axis.x.forceVisible) && (e = n.isWithinBounds(n.axis.x.track.rect)), (n.axis.y.isOverflowing || n.axis.y.forceVisible) && (r = n.isWithinBounds(n.axis.y.track.rect)), (e || r) && (t.preventDefault(), t.stopPropagation(), "mousedown" === t.type && (e && (n.axis.x.scrollbar.rect = n.axis.x.scrollbar.el.getBoundingClientRect(), n.isWithinBounds(n.axis.x.scrollbar.rect) ? n.onDragStart(t, "x") : n.onTrackClick(t, "x")), r && (n.axis.y.scrollbar.rect = n.axis.y.scrollbar.el.getBoundingClientRect(), n.isWithinBounds(n.axis.y.scrollbar.rect) ? n.onDragStart(t, "y") : n.onTrackClick(t, "y"))))
			}, this.drag = function (e) {
				var r = n.axis[n.draggedAxis].track, i = r.rect[n.axis[n.draggedAxis].sizeAttr], o = n.axis[n.draggedAxis].scrollbar, s = n.contentWrapperEl[n.axis[n.draggedAxis].scrollSizeAttr], a = parseInt(n.elStyles[n.axis[n.draggedAxis].sizeAttr], 10);
				e.preventDefault(), e.stopPropagation();
				var c = (("y" === n.draggedAxis ? e.pageY : e.pageX) - r.rect[n.axis[n.draggedAxis].offsetAttr] - n.axis[n.draggedAxis].dragOffset) / (i - o.size) * (s - a);
				"x" === n.draggedAxis && (c = n.isRtl && t.getRtlHelpers().isRtlScrollbarInverted ? c - (i + o.size) : c, c = n.isRtl && t.getRtlHelpers().isRtlScrollingInverted ? -c : c), n.contentWrapperEl[n.axis[n.draggedAxis].scrollOffsetAttr] = c
			}, this.onEndDrag = function (t) {
				var e = Xi(n.el), r = $i(n.el);
				t.preventDefault(), t.stopPropagation(), n.el.classList.remove(n.classNames.dragging), e.removeEventListener("mousemove", n.drag, !0), e.removeEventListener("mouseup", n.onEndDrag, !0), n.removePreventClickId = r.setTimeout((function () {
					e.removeEventListener("click", n.preventClick, !0), e.removeEventListener("dblclick", n.preventClick, !0), n.removePreventClickId = null
				}))
			}, this.preventClick = function (t) {
				t.preventDefault(), t.stopPropagation()
			}, this.el = e, this.minScrollbarWidth = 20, this.options = Object.assign({}, t.defaultOptions, {}, r), this.classNames = Object.assign({}, t.defaultOptions.classNames, {}, this.options.classNames), this.axis = {x: {scrollOffsetAttr: "scrollLeft", sizeAttr: "width", scrollSizeAttr: "scrollWidth", offsetSizeAttr: "offsetWidth", offsetAttr: "left", overflowAttr: "overflowX", dragOffset: 0, isOverflowing: !0, isVisible: !1, forceVisible: !1, track: {}, scrollbar: {}}, y: {scrollOffsetAttr: "scrollTop", sizeAttr: "height", scrollSizeAttr: "scrollHeight", offsetSizeAttr: "offsetHeight", offsetAttr: "top", overflowAttr: "overflowY", dragOffset: 0, isOverflowing: !0, isVisible: !1, forceVisible: !1, track: {}, scrollbar: {}}}, this.removePreventClickId = null, t.instances.has(this.el) || (this.recalculate = Gr(this.recalculate.bind(this), 64), this.onMouseMove = Gr(this.onMouseMove.bind(this), 64), this.hideScrollbars = dn(this.hideScrollbars.bind(this), this.options.timeout), this.onWindowResize = dn(this.onWindowResize.bind(this), 64, {leading: !0}), t.getRtlHelpers = Hn(t.getRtlHelpers), this.init())
		}
		t.getRtlHelpers = function () {
			var e = document.createElement("div");
			e.innerHTML = '<div class="hs-dummy-scrollbar-size"><div style="height: 200%; width: 200%; margin: 10px 0;"></div></div>';
			var r = e.firstElementChild;
			document.body.appendChild(r);
			var n = r.firstElementChild;
			r.scrollLeft = 0;
			var i = t.getOffset(r), o = t.getOffset(n);
			r.scrollLeft = 999;
			var s = t.getOffset(n);
			return{isRtlScrollingInverted: i.left !== o.left && o.left - s.left != 0, isRtlScrollbarInverted: i.left !== o.left}
		}, t.getOffset = function (t) {
			var e = t.getBoundingClientRect(), r = Xi(t), n = $i(t);
			return{top: e.top + (n.pageYOffset || r.documentElement.scrollTop), left: e.left + (n.pageXOffset || r.documentElement.scrollLeft)}
		};
		var e = t.prototype;
		return e.init = function () {
			t.instances.set(this.el, this), Yt && (this.initDOM(), this.scrollbarWidth = this.getScrollbarWidth(), this.recalculate(), this.initListeners())
		}, e.initDOM = function () {
			var t = this;
			Xi(this.el);
			if (Array.prototype.filter.call(this.el.children, (function (e) {
				return e.classList.contains(t.classNames.wrapper)
			})).length)
				this.wrapperEl = this.el.querySelector("." + this.classNames.wrapper), this.contentWrapperEl = this.options.scrollableNode || this.el.querySelector("." + this.classNames.contentWrapper), this.contentEl = this.options.contentNode || this.el.querySelector("." + this.classNames.contentEl), this.offsetEl = this.el.querySelector("." + this.classNames.offset), this.maskEl = this.el.querySelector("." + this.classNames.mask), this.placeholderEl = this.findChild(this.wrapperEl, "." + this.classNames.placeholder), this.heightAutoObserverWrapperEl = this.el.querySelector("." + this.classNames.heightAutoObserverWrapperEl), this.heightAutoObserverEl = this.el.querySelector("." + this.classNames.heightAutoObserverEl), this.axis.x.track.el = this.findChild(this.el, "." + this.classNames.track + "." + this.classNames.horizontal), this.axis.y.track.el = this.findChild(this.el, "." + this.classNames.track + "." + this.classNames.vertical);
			else {
				for (this.wrapperEl = document.createElement("div"), this.contentWrapperEl = document.createElement("div"), this.offsetEl = document.createElement("div"), this.maskEl = document.createElement("div"), this.contentEl = document.createElement("div"), this.placeholderEl = document.createElement("div"), this.heightAutoObserverWrapperEl = document.createElement("div"), this.heightAutoObserverEl = document.createElement("div"), this.wrapperEl.classList.add(this.classNames.wrapper), this.contentWrapperEl.classList.add(this.classNames.contentWrapper), this.offsetEl.classList.add(this.classNames.offset), this.maskEl.classList.add(this.classNames.mask), this.contentEl.classList.add(this.classNames.contentEl), this.placeholderEl.classList.add(this.classNames.placeholder), this.heightAutoObserverWrapperEl.classList.add(this.classNames.heightAutoObserverWrapperEl), this.heightAutoObserverEl.classList.add(this.classNames.heightAutoObserverEl); this.el.firstChild; )
					this.contentEl.appendChild(this.el.firstChild);
				this.contentWrapperEl.appendChild(this.contentEl), this.offsetEl.appendChild(this.contentWrapperEl), this.maskEl.appendChild(this.offsetEl), this.heightAutoObserverWrapperEl.appendChild(this.heightAutoObserverEl), this.wrapperEl.appendChild(this.heightAutoObserverWrapperEl), this.wrapperEl.appendChild(this.maskEl), this.wrapperEl.appendChild(this.placeholderEl), this.el.appendChild(this.wrapperEl)
			}
			if (!this.axis.x.track.el || !this.axis.y.track.el) {
				var e = document.createElement("div"), r = document.createElement("div");
				e.classList.add(this.classNames.track), r.classList.add(this.classNames.scrollbar), e.appendChild(r), this.axis.x.track.el = e.cloneNode(!0), this.axis.x.track.el.classList.add(this.classNames.horizontal), this.axis.y.track.el = e.cloneNode(!0), this.axis.y.track.el.classList.add(this.classNames.vertical), this.el.appendChild(this.axis.x.track.el), this.el.appendChild(this.axis.y.track.el)
			}
			this.axis.x.scrollbar.el = this.axis.x.track.el.querySelector("." + this.classNames.scrollbar), this.axis.y.scrollbar.el = this.axis.y.track.el.querySelector("." + this.classNames.scrollbar), this.options.autoHide || (this.axis.x.scrollbar.el.classList.add(this.classNames.visible), this.axis.y.scrollbar.el.classList.add(this.classNames.visible)), this.el.setAttribute("data-simplebar", "init")
		}, e.initListeners = function () {
			var t = this, e = $i(this.el);
			this.options.autoHide && this.el.addEventListener("mouseenter", this.onMouseEnter), ["mousedown", "click", "dblclick"].forEach((function (e) {
				t.el.addEventListener(e, t.onPointerEvent, !0)
			})), ["touchstart", "touchend", "touchmove"].forEach((function (e) {
				t.el.addEventListener(e, t.onPointerEvent, {capture: !0, passive: !0})
			})), this.el.addEventListener("mousemove", this.onMouseMove), this.el.addEventListener("mouseleave", this.onMouseLeave), this.contentWrapperEl.addEventListener("scroll", this.onScroll), e.addEventListener("resize", this.onWindowResize);
			var r = !1, n = e.ResizeObserver || di;
			this.resizeObserver = new n((function () {
				r && t.recalculate()
			})), this.resizeObserver.observe(this.el), this.resizeObserver.observe(this.contentEl), e.requestAnimationFrame((function () {
				r = !0
			})), this.mutationObserver = new e.MutationObserver(this.recalculate), this.mutationObserver.observe(this.contentEl, {
				childList: !0,
				subtree: !0,
				characterData: !0})
		},
			e.recalculate = function () {
				var t = $i(this.el);
				this.elStyles = t.getComputedStyle(this.el),
					this.isRtl = "rtl" === this.elStyles.direction;
				var e = this.heightAutoObserverEl.offsetHeight <= 1,
					r = this.heightAutoObserverEl.offsetWidth <= 1,
					n = this.contentEl.offsetWidth,
					i = this.contentWrapperEl.offsetWidth,
					o = this.elStyles.overflowX,
					s = this.elStyles.overflowY;
				this.contentEl.style.padding = this.elStyles.paddingTop + " " + this.elStyles.paddingRight + " " + this.elStyles.paddingBottom + " " + this.elStyles.paddingLeft, this.wrapperEl.style.margin = "-" + this.elStyles.paddingTop + " -" + this.elStyles.paddingRight + " -" + this.elStyles.paddingBottom + " -" + this.elStyles.paddingLeft;
				var a = this.contentEl.scrollHeight, c = this.contentEl.scrollWidth;
				this.contentWrapperEl.style.height = e ? "auto" : "100%", this.placeholderEl.style.width = r ? n + "px" : "auto", this.placeholderEl.style.height = a + "px";
				var l = this.contentWrapperEl.offsetHeight;
				this.axis.x.isOverflowing = c > n, this.axis.y.isOverflowing = a > l, this.axis.x.isOverflowing = "hidden" !== o && this.axis.x.isOverflowing, this.axis.y.isOverflowing = "hidden" !== s && this.axis.y.isOverflowing, this.axis.x.forceVisible = "x" === this.options.forceVisible || !0 === this.options.forceVisible,
					this.axis.y.forceVisible = "y" === this.options.forceVisible || !0 === this.options.forceVisible,
					this.hideNativeScrollbar();
				var u = this.axis.x.isOverflowing ? this.scrollbarWidth : 0,
					f = this.axis.y.isOverflowing ? this.scrollbarWidth : 0;
				this.axis.x.isOverflowing = this.axis.x.isOverflowing && c > i - f,
					this.axis.y.isOverflowing = this.axis.y.isOverflowing && a > l - u,
					this.axis.x.scrollbar.size = this.getScrollbarSize("x"),
					this.axis.y.scrollbar.size = this.getScrollbarSize("y"),
					this.axis.x.scrollbar.el.style.width = this.axis.x.scrollbar.size + "px",
					this.axis.y.scrollbar.el.style.height = this.axis.y.scrollbar.size + "px",
					this.positionScrollbar("x"),
					this.positionScrollbar("y"),
					this.toggleTrackVisibility("x"),
					this.toggleTrackVisibility("y")
			},
			e.getScrollbarSize = function (t) {
				if (void 0 === t && (t = "y"),
					!this.axis[t].isOverflowing)
					return 0;
				var e, r = this.contentEl[this.axis[t].scrollSizeAttr],
					n = this.axis[t].track.el[this.axis[t].offsetSizeAttr],
					i = n / r;
				return e = Math.max(~~(i * n), this.options.scrollbarMinSize),
					this.options.scrollbarMaxSize && (e = Math.min(e, this.options.scrollbarMaxSize)), e
			},
			e.positionScrollbar = function (e) {
				if (void 0 === e && (e = "y"), this.axis[e].isOverflowing) {
					var r = this.contentWrapperEl[this.axis[e].scrollSizeAttr],
						n = this.axis[e].track.el[this.axis[e].offsetSizeAttr],
						i = parseInt(this.elStyles[this.axis[e].sizeAttr], 10),
						o = this.axis[e].scrollbar,
						s = this.contentWrapperEl[this.axis[e].scrollOffsetAttr],
						a = (s = "x" === e && this.isRtl && t.getRtlHelpers().isRtlScrollingInverted ? -s : s) / (r - i),
						c = ~~((n - o.size) * a);
					c = "x" === e && this.isRtl && t.getRtlHelpers().isRtlScrollbarInverted ? c + (n - o.size) : c,
						o.el.style.transform = "x" === e ? "translate3d(" + c + "px, 0, 0)" : "translate3d(0, " + c + "px, 0)"
				}
			},
			e.toggleTrackVisibility = function (t) {
				void 0 === t && (t = "y");
				var e = this.axis[t].track.el;
				var r = this.axis[t].scrollbar.el;
				this.axis[t].isOverflowing || this.axis[t].forceVisible ? (e.style.visibility = "visible", this.contentWrapperEl.style[this.axis[t].overflowAttr] = "scroll") : (e.style.visibility = "hidden", this.contentWrapperEl.style[this.axis[t].overflowAttr] = "hidden"),
					this.axis[t].isOverflowing ? r.style.display = "block" : r.style.display = "none"
			}, e.hideNativeScrollbar = function () {
			this.offsetEl.style[this.isRtl ? "left" : "right"] = this.axis.y.isOverflowing || this.axis.y.forceVisible ? "-" + this.scrollbarWidth + "px" : 0, this.offsetEl.style.bottom = this.axis.x.isOverflowing || this.axis.x.forceVisible ? "-" + this.scrollbarWidth + "px" : 0
		}, e.onMouseMoveForAxis = function (t) {
			void 0 === t && (t = "y"), this.axis[t].track.rect = this.axis[t].track.el.getBoundingClientRect(), this.axis[t].scrollbar.rect = this.axis[t].scrollbar.el.getBoundingClientRect(), this.isWithinBounds(this.axis[t].scrollbar.rect) ? this.axis[t].scrollbar.el.classList.add(this.classNames.hover) : this.axis[t].scrollbar.el.classList.remove(this.classNames.hover), this.isWithinBounds(this.axis[t].track.rect) ? (this.showScrollbar(t), this.axis[t].track.el.classList.add(this.classNames.hover)) : this.axis[t].track.el.classList.remove(this.classNames.hover)
		}, e.onMouseLeaveForAxis = function (t) {
			void 0 === t && (t = "y"), this.axis[t].track.el.classList.remove(this.classNames.hover), this.axis[t].scrollbar.el.classList.remove(this.classNames.hover)
		}, e.showScrollbar = function (t) {
			void 0 === t && (t = "y");
			var e = this.axis[t].scrollbar.el;
			this.axis[t].isVisible || (e.classList.add(this.classNames.visible), this.axis[t].isVisible = !0), this.options.autoHide && this.hideScrollbars()
		}, e.onDragStart = function (t, e) {
			void 0 === e && (e = "y");
			var r = Xi(this.el), n = $i(this.el), i = this.axis[e].scrollbar, o = "y" === e ? t.pageY : t.pageX;
			this.axis[e].dragOffset = o - i.rect[this.axis[e].offsetAttr], this.draggedAxis = e, this.el.classList.add(this.classNames.dragging), r.addEventListener("mousemove", this.drag, !0), r.addEventListener("mouseup", this.onEndDrag, !0), null === this.removePreventClickId ? (r.addEventListener("click", this.preventClick, !0), r.addEventListener("dblclick", this.preventClick, !0)) : (n.clearTimeout(this.removePreventClickId), this.removePreventClickId = null)
		}, e.onTrackClick = function (t, e) {
			var r = this;
			if (void 0 === e && (e = "y"), this.options.clickOnTrack) {
				var n = $i(this.el);
				this.axis[e].scrollbar.rect = this.axis[e].scrollbar.el.getBoundingClientRect();
				var i = this.axis[e].scrollbar.rect[this.axis[e].offsetAttr], o = parseInt(this.elStyles[this.axis[e].sizeAttr], 10), s = this.contentWrapperEl[this.axis[e].scrollOffsetAttr], a = ("y" === e ? this.mouseY - i : this.mouseX - i) < 0 ? -1 : 1, c = -1 === a ? s - o : s + o;
				!function t() {
					var i, o;
					-1 === a ? s > c && (s -= 40, r.contentWrapperEl.scrollTo(((i = {})[r.axis[e].offsetAttr] = s, i)), n.requestAnimationFrame(t)) : s < c && (s += 40, r.contentWrapperEl.scrollTo(((o = {})[r.axis[e].offsetAttr] = s, o)), n.requestAnimationFrame(t))
				}()
			}
		}, e.getContentElement = function () {
			return this.contentEl
		}, e.getScrollElement = function () {
			return this.contentWrapperEl
		}, e.getScrollbarWidth = function () {
			try {
				return"none" === getComputedStyle(this.contentWrapperEl, "::-webkit-scrollbar").display || "scrollbarWidth"in document.documentElement.style || "-ms-overflow-style"in document.documentElement.style ? 0 : gi()
			} catch (t) {
				return gi()
			}
		}, e.removeListeners = function () {
			var t = this, e = $i(this.el);
			this.options.autoHide && this.el.removeEventListener("mouseenter", this.onMouseEnter), ["mousedown", "click", "dblclick"].forEach((function (e) {
				t.el.removeEventListener(e, t.onPointerEvent, !0)
			})), ["touchstart", "touchend", "touchmove"].forEach((function (e) {
				t.el.removeEventListener(e, t.onPointerEvent, {capture: !0, passive: !0})
			})), this.el.removeEventListener("mousemove", this.onMouseMove), this.el.removeEventListener("mouseleave", this.onMouseLeave), this.contentWrapperEl.removeEventListener("scroll", this.onScroll), e.removeEventListener("resize", this.onWindowResize), this.mutationObserver.disconnect(), this.resizeObserver.disconnect(), this.recalculate.cancel(), this.onMouseMove.cancel(), this.hideScrollbars.cancel(), this.onWindowResize.cancel()
		}, e.unMount = function () {
			this.removeListeners(), t.instances.delete(this.el)
		}, e.isWithinBounds = function (t) {
			return this.mouseX >= t.left && this.mouseX <= t.left + t.width && this.mouseY >= t.top && this.mouseY <= t.top + t.height
		}, e.findChild = function (t, e) {
			var r = t.matches || t.webkitMatchesSelector || t.mozMatchesSelector || t.msMatchesSelector;
			return Array.prototype.filter.call(t.children, (function (t) {
				return r.call(t, e)
			}))[0]
		}, t
	}();
	return Yi.defaultOptions = {
		autoHide: !0,
		forceVisible: !1,
		clickOnTrack: !0,
		classNames: {
			contentEl: "simplebar-content",
			contentWrapper: "simplebar-content-wrapper",
			offset: "simplebar-offset",
			mask: "simplebar-mask",
			wrapper: "simplebar-wrapper",
			placeholder: "simplebar-placeholder",
			scrollbar: "simplebar-scrollbar",
			track: "simplebar-track",
			heightAutoObserverWrapperEl: "simplebar-height-auto-observer-wrapper",
			heightAutoObserverEl: "simplebar-height-auto-observer",
			visible: "simplebar-visible",
			horizontal: "simplebar-horizontal",
			vertical: "simplebar-vertical",
			hover: "simplebar-hover",
			dragging: "simplebar-dragging"
		},
		scrollbarMinSize: 25,
		scrollbarMaxSize: 0,
		timeout: 1e3
	},
		Yi.instances = new WeakMap,
		Yi.initDOMLoadedElements = function () {
			document.removeEventListener("DOMContentLoaded", this.initDOMLoadedElements),
				window.removeEventListener("load", this.initDOMLoadedElements),
				Array.prototype.forEach.call(document.querySelectorAll('[data-simplebar]:not([data-simplebar="init"])'), (function (t) {
					Yi.instances.has(t) || new Yi(t, qi(t.attributes))
				}))
		}, Yi.removeObserver = function () {
		this.globalObserver.disconnect()
	}, Yi.initHtmlApi = function () {
		this.initDOMLoadedElements = this.initDOMLoadedElements.bind(this);
		if ("undefined" != typeof MutationObserver) {
			this.globalObserver = new MutationObserver(Yi.handleMutations);
			this.globalObserver.observe(document, {childList: !0, subtree: !0});
		}
		if ("complete" === document.readyState || "loading" !== document.readyState && !document.documentElement.doScroll) {
			window.setTimeout(this.initDOMLoadedElements)
		} else {
			document.addEventListener("DOMContentLoaded", this.initDOMLoadedElements);
			window.addEventListener("load", this.initDOMLoadedElements);
		}
	}, Yi.handleMutations = function (t) {
		t.forEach((function (t) {
			Array.prototype.forEach.call(t.addedNodes, (function (t) {
				if (1 === t.nodeType) {
					if (t.hasAttribute("data-simplebar")) {
						if (!Yi.instances.has(t)) {
							new Yi(t, qi(t.attributes));
						}
					} else {
						var ar;
						try {
							ar = t.querySelectorAll('[data-simplebar]:not([data-simplebar="init"])');
						} catch (e) {
							ar = [];
						}
						Array.prototype.forEach.call(ar, function (t) {
							if (!Yi.instances.has(t)) {
								new Yi(t, qi(t.attributes));
							}

						});
					}
				}
			}));
			Array.prototype.forEach.call(t.removedNodes, (function (t) {
				1 === t.nodeType && (t.hasAttribute('[data-simplebar="init"]') ? Yi.instances.has(t) && Yi.instances.get(t).unMount() : Array.prototype.forEach.call(t.querySelectorAll('[data-simplebar="init"]'), (function (t) {
					Yi.instances.has(t) && Yi.instances.get(t).unMount()
				})));
			}));
		}))
	}, Yi.getOptions = qi, Yt && Yi.initHtmlApi(), Yi
}));
